var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 12.02 C 0 5.414 5.373 0.058 12 0.058 C 18.627 0.058 24 5.414 24 12.02 C 24 18.627 18.627 23.983 12 23.983 C 5.373 23.983 0 18.627 0 12.02 Z",
    fill: "rgb(240,240,240)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 24 12.02 C 24 6.877 20.743 2.492 16.174 0.802 L 16.174 23.239 C 20.743 21.549 24 17.164 24 12.02 Z",
    fill: "rgb(216,0,39)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 12.02 C 0 17.164 3.256 21.549 7.826 23.239 L 7.826 0.802 C 3.256 2.492 0 6.877 0 12.02 Z",
    fill: "rgb(0,82,180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/France.566e6e3bc2fe76830b526991d932fa02.svg";
export { ForwardRef as ReactComponent };